module.exports = __webpack_public_path__ + "static/media/comment-alt-times.9999a5a1.svg";